export const MAIN_NAV_ITEMS = [
    { id: "home", href: "/" },
    { id: "services", href: "/security" },
    { id: "technology", href: "/technology" },
    { id: "jobs", href: "/jobs" },
    { id: "contact", href: "/contact" },
] as const;

export const ACADEMY_NAV_ITEM = { id: "academy", href: "https://oe-academy.com" } as const;

export const NAV_ITEMS = [...MAIN_NAV_ITEMS, ACADEMY_NAV_ITEM] as const;

export type HeaderNavId = (typeof NAV_ITEMS)[number]["id"];
